import { PaymentModePolicy } from "constants/charge/PaymentModePolicy";
import { CollectionDetailEntity, EMPTY_COLLECTION_DETAIL_ENTITY } from "domain/entity/Collection/CollectionDetailEntity";
import { CollectionDetailSearchCriteria, EMPTY_COLLECTION_DTL_SEARCH_CRITERIA } from "domain/entity/Collection/CollectionDetailSearchCriteria";
import { CollectionHeaderEntity } from "domain/entity/Collection/CollectionHeaderEntity";
import { CollectionHeaderSearchCriteria, EMPTY_COLLECTION_HDR_SEARCH_CRITERIA } from "domain/entity/Collection/CollectionHeaderSearchCriteria";
import { CompanyCodeEntity } from "domain/entity/Company/CompanyCodeEntity";
import { BankerRepository } from "domain/repository/Banker/BankerRepo";
import { CollectionRepository } from "domain/repository/Collection/CollectionRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import _ from "lodash";
import moment from "moment";
import { createCollectionValidationSchema, createPOCollectionValidationSchema } from "presentation/constant/Collection/CollectionValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { CollectionModel } from "presentation/model/Collection/CollectionModel";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface CollectionVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<CollectionModel>> | ((value: SetStateAction<CollectionModel>) => void),
    ],
    repo: CollectionRepository,
    bankerRepo: BankerRepository,
    companyRepo: CompanyRepository,
}

export const CollectionVM = ({ dispatch, repo, bankerRepo, companyRepo }: CollectionVMProps) => {
    const [collectionDispatch] = dispatch;

    const onSearch = async (searchCriteria: CollectionHeaderSearchCriteria) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                // collectionHdrList: [],
                selectedRows: [],
                searchCriteria: searchCriteria,
                isShowDetailPanel: false,
                isShowEditPanel: false
            }
        });
        await repo.searchCollectionHdrEntities(searchCriteria).then((data) => {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    collectionHdrList: data,
                }
            });
        });
    }
    const onApplyCollection = async (criteria: CollectionDetailSearchCriteria) => {
        /*await repo.searchCollectionHdrEntities(searchCriteria).then((data) => {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    collectionHdrList: data,
                }
            });
        });*/
        await repo.saveCollectionHdr(criteria).then(async data => {
            if (data && data.success) {
                // const ret = data.data;
            }
        })
    }
    const onSearchDtl = async (criteria: CollectionDetailSearchCriteria) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                collectionDtlList: [],
                selectedDtlRows: [],
                isShowEditPanel: false,
            }
        })
        let msg = '';
        await repo.searchCollectionDtlEntities(criteria).then(async data => {
            if (data && data.success) {
                const ret = data.data;
                // await loadDropdownOption();
                const dataList: CollectionDetailEntity[] = ret["voList"] ? ret["voList"] : [];
                const payeeList: CompanyCodeEntity[] = ret["payeeList"] ? ret["payeeList"] : [];
                const draftInvoiceNos: string = ret["draftInvoiceNos"] ? ret["draftInvoiceNos"] : "";
                const totalInvAmt: number = ret["totalInvAmt"] ? ret["totalInvAmt"] : 0;
                const unPaidHdrList: number[] = ret["unPaidHdrList"] ? ret["unPaidHdrList"] : [];
                const observation: string = ret["observation"] ? ret["observation"] : "";
                let payeeDropdownOptions = payeeList?.map((ety) => ({
                    dropdownLabel: ety.companyCode,
                    tagLabel: ety.companyCode,
                    value: ety.companyCode,
                    label: ety.companyCode,
                })) ?? []

                collectionDispatch(prevState => {
                    return {
                        ...prevState,
                        collectionDtlList: dataList,
                        selectedDtlRows: [],
                        isShowDetailPanel: true,
                        isShowSearchPanel: false,
                        draftInvoiceNos: draftInvoiceNos,
                        totalInvAmt: totalInvAmt,
                        observation: observation,
                        dynamicOptions: {
                            ...prevState.dynamicOptions,
                            payeeDropdownOptions: payeeDropdownOptions,
                        },
                        payeeNameList: payeeList,
                        unPaidHdrList: unPaidHdrList,
                    }
                })
            } else {
                msg = data.data;
            }
        });
        return msg;
    }

    const onRowDoubleClick = async (allRows: CollectionHeaderEntity[], entity: CollectionHeaderEntity) => {
        let criteria = { ...EMPTY_COLLECTION_DTL_SEARCH_CRITERIA };
        criteria = {
            ...criteria,
            selectRows: [entity],
            allRows: allRows
        }
        collectionDispatch(prevState => {
            return {
                ...prevState,
                currentRow: entity,
            }
        })
        let msg = '';
        await onSearchDtl(criteria).then(data => {
            if (data) {
                msg = data;
            }
        });
        return msg;
    }

    const onDtlRowDoubleClick = async (entity: CollectionDetailEntity) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                currentDtlRow: entity,
            }
        })
    }

    const updateSelectedRows = async (rows: CollectionHeaderEntity[]) => {

        collectionDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const updateSelectedDtlRows = async (rows: CollectionDetailEntity[]) => {

        collectionDispatch(prevState => {
            return {
                ...prevState,
                selectedDtlRows: rows,
                currentDtlRow: rows.length === 1 ? rows[0] : { ...EMPTY_COLLECTION_DETAIL_ENTITY },
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onSearchCriteriaResetClick = async (operatingUnit: string) => {

        collectionDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...EMPTY_COLLECTION_HDR_SEARCH_CRITERIA,
                    dateFrom: (operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? moment().startOf("day").toDate() : null,
                    notYetFinal: (operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? "Y" : "N"
                }
            }
        })
    }

    const onSearchClick = async () => {

        collectionDispatch(prevState => {
            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel
            }
        })
    }

    const onDeleteHdrClick = async (rows: CollectionHeaderEntity[]) => {
        return await repo.deleteCollectionHdr(rows);
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        collectionDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if ("observation" === fieldKey) {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    searchCriteria: {
                        ...prevState.searchCriteria,
                        [fieldKey]: val,
                    },
                    [fieldKey]: val,
                }
            })
        }
        collectionDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onEditFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if ("payOrderAmount" === fieldKey) {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    currentDtlEditRow: {
                        ...prevState.currentDtlEditRow,
                        [fieldKey]: val,
                        paymentAmount: val,
                    },
                    allFormState: {
                        ...prevState.allFormState,
                        [fieldKey]: '',
                    },
                }
            })
        } else if ("paymentMode" === fieldKey) {
            collectionDispatch(prevState => {
                let bankCode = "";
                if (val === 'PO') {
                    bankCode = !_.isEmpty(prevState.dynamicOptions.bankCodeDropdownOptions) ? prevState.dynamicOptions.bankCodeDropdownOptions[0].value : "";
                }
                const amount = prevState.totalInvAmt - (prevState.collectionDtlList?.reduce((sum, item) => sum + (item.paymentAmount ?? 0), 0));
                return {
                    ...prevState,
                    currentDtlEditRow: {
                        ...prevState.currentDtlEditRow,
                        [fieldKey]: val,
                        payOrderNo: null,
                        bankCode: bankCode,
                        payOrderAmount: null,
                        paymentAmount: amount
                    },
                    allFormState: {
                        ...prevState.allFormState,
                        [fieldKey]: '',
                        bankCode: '',
                    },
                }
            })
        } else if ("payee" === fieldKey) {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    currentDtlEditRow: {
                        ...prevState.currentDtlEditRow,
                        [fieldKey]: val,
                        payeeName: !_.isEmpty(prevState.payeeNameList) ? prevState.payeeNameList.find(company => company.companyCode === val)?.companyName : ''
                    },
                    allFormState: {
                        ...prevState.allFormState,
                        [fieldKey]: '',
                    },
                }
            })
        } else {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    currentDtlEditRow: {
                        ...prevState.currentDtlEditRow,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        ...prevState.allFormState,
                        [fieldKey]: '',
                    },
                }
            })
        }

    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    const onCloseClick = () => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                isShowDetailPanel: !prevState.isEditingHdr ? false : true,
                isEditingHdr: false,
                isReselectRows: true,
                tempSelectedRows: prevState.selectedRows,
            }
        })
    }
    const onEditHeaderCick = () => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                isEditingHdr: true,
            }
        })
    }

    const onCloseEidtPanel = () => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                currentDtlAddRowList: []
            }
        })
    }

    const onTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>, fieldName: string, toUpperCase: boolean = false) => {
        const val = toUpperCase ? e.target.value.toUpperCase() : e.target.value;

        collectionDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: val === "" ? null : val.split(',')
            },
        }))
    };

    const loadDropdownOption = async () => {

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let newCompanies = companies.filter(entity => entity.customerType !== 'SL' && entity.companyType !== 'MASTER' && entity.companyType !== 'ALLIANCE');
                let companyCodeDropdownOption = newCompanies?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.companyCode,
                    value: company.companyCode,
                })) ?? []
                companyCodeDropdownOption = _.orderBy(companyCodeDropdownOption, "dropdownLabel");

                collectionDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyCodeDropdownOptions: companyCodeDropdownOption,

                    }
                }))
            }
        );

        await bankerRepo.getEntities().then(
            bankers => {
                let newBankers = bankers.filter(entity => entity.activeInd === 'Y');
                let bankCodeDropdownOption = newBankers?.map((banker) => ({
                    dropdownLabel: banker.bankCode,
                    tagLabel: banker.bankCode,
                    value: banker.bankCode,
                    label: banker.bankCode,
                })) ?? []
                bankCodeDropdownOption = _.orderBy(bankCodeDropdownOption, "dropdownLabel");

                collectionDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        bankCodeDropdownOptions: bankCodeDropdownOption,
                    }
                }))
            }
        );
        collectionDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                paymentModeDropdownOptions: PaymentModePolicy().getCollectionPaymentModeDroOptsForSAPT(),
            }
        }))

    }

    const onShowEditPanel = async (isAdd: boolean) => {
        let msg = "";
        collectionDispatch(prevState => {
            const amount = prevState.totalInvAmt - (prevState.collectionDtlList?.reduce((sum, item) => sum + (item.paymentAmount ?? 0), 0));
            console.log("totalInvAmt:" + prevState.totalInvAmt);
            console.log("amount:" + amount);
            if (isAdd && amount <= 0) {
                msg = "All invoices are full paid.";
                return {
                    ...prevState,
                    isShowEditPanel: false,
                }
            } else {
                const payee = !_.isEmpty(prevState.dynamicOptions.payeeDropdownOptions) ? prevState.dynamicOptions.payeeDropdownOptions[0].value : null;
                const paymentMode = !_.isEmpty(prevState.dynamicOptions.paymentModeDropdownOptions) ? prevState.dynamicOptions.paymentModeDropdownOptions[0].value : null;
                const bankCode = !_.isEmpty(prevState.dynamicOptions.bankCodeDropdownOptions) ? prevState.dynamicOptions.bankCodeDropdownOptions[0].value : null;
                let newDtl = { ...EMPTY_COLLECTION_DETAIL_ENTITY };
                newDtl = {
                    ...newDtl,
                    paymentMode: paymentMode,
                    payee: payee,
                    bankCode: bankCode,
                    paymentAmount: amount,
                    payeeName: payee ? prevState.payeeNameList.find(company => company.companyCode === payee)?.companyName : null
                }
                return {
                    ...prevState,
                    isShowEditPanel: true,
                    currentDtlEditRow: isAdd ? newDtl : prevState.currentDtlRow,
                    isAdd: isAdd,
                    isEdit: !isAdd
                }
            }
        })
        return msg;
    }

    const onShowAddPanel = async (isAdd: boolean) => {
        let msg = "";
        collectionDispatch(prevState => {
            const amount = prevState.totalInvAmt - ((prevState.collectionDtlList)?.reduce((sum, item) => sum + (Number(item.paymentAmount ?? 0)), 0));
            console.log("totalInvAmt:" + prevState.totalInvAmt);
            console.log("amount:" + amount);
            if (isAdd && amount <= 0) {
                msg = "All invoices are full paid.";
                return {
                    ...prevState,
                    isShowEditPanel: false,
                }
            } else {
                const currentDtlAddRowList = [];

                for (let i = 0; i < 20; i++) {
                    let newDtl = {
                        ...EMPTY_COLLECTION_DETAIL_ENTITY,
                        dummyKey: _.uniqueId(),
                    };

                    newDtl = {
                        ...newDtl,
                        paymentAmount: amount,
                    };

                    currentDtlAddRowList.push(newDtl);
                }

                return {
                    ...prevState,
                    isShowEditPanel: true,
                    isAdd: isAdd,
                    isEdit: !isAdd,
                    currentDtlAddRowList: currentDtlAddRowList
                }
            }
        })
        return msg;
    }

    const onEditTempPaymentData = async (newData: CollectionDetailEntity[]) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                collectionDtlList: newData
            }
        })
    }

    const onSaveCollectionDtl = async (criteria: CollectionDetailSearchCriteria) => {
        return await repo.saveCollectionDtl(criteria);
    }

    const onSaveClicked = async (currentDtlEditRow: CollectionDetailEntity) => {
        let validatedResult: { [x: string]: string } = {};
        const valResult = await Validation(createCollectionValidationSchema).ValidateFormOnly(currentDtlEditRow);
        if (valResult) {
            validatedResult = { ...valResult };
        }
        if (currentDtlEditRow.paymentMode === 'PO') {
            const result = await Validation(createPOCollectionValidationSchema).ValidateFormOnly(currentDtlEditRow);
            if (result) {
                validatedResult = { ...validatedResult, ...result };
            }
        }
        if (Object.keys(validatedResult).length !== 0) {
            collectionDispatch(prevState => {
                return {
                    ...prevState,
                    allFormState: {
                        ...validatedResult
                    },
                }
            });
            return true;
        } else {
            return false;
        }
    }

    const onDeleteCollectionDtl = async (criteria: CollectionDetailSearchCriteria) => {
        return await repo.delCollectionDtl(criteria);
    }

    const onleaveDtl = async (criteria: CollectionDetailSearchCriteria) => {
        return await repo.onleaveDtl(criteria);
    }

    const onConfirmHdr = async (criteria: CollectionDetailSearchCriteria) => {
        let msg = '';
        await repo.confirmCollectionHdr(criteria).then(data => {
            if (data && data.success) {
                for (const key in data.data) {
                    const dat = data.data;
                    if (dat[key] != null && dat[key] !== undefined) {
                        const tempData = dat[key] as string;

                        let base64 = tempData
                        let bstr = atob(base64)
                        let n = bstr.length
                        let u8arr = new Uint8Array(n)
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n)
                        }
                        const blob = new Blob([u8arr], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);

                        window.open(url, '_blank');
                        URL.revokeObjectURL(url);
                    }
                };
            } else {
                msg = data.data ?? "Confirm failed.";
            }
        });
        return msg;
    }

    const onReprint = async (rows: CollectionHeaderEntity[]) => {
        let msg = '';
        await repo.onReprint(rows).then(data => {
            if (data && data.success) {
                for (const key in data.data) {
                    const dat = data.data;
                    if (dat[key] != null && dat[key] !== undefined) {
                        const tempData = dat[key] as string;

                        let base64 = tempData
                        let bstr = atob(base64)
                        let n = bstr.length
                        let u8arr = new Uint8Array(n)
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n)
                        }
                        const blob = new Blob([u8arr], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);

                        window.open(url, '_blank');
                        URL.revokeObjectURL(url);
                    }
                };
            } else {
                msg = data.data ?? "Print report failed.";
            }
        });
        return msg;
    }

    const searchDtl = async (ids: number[]) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                collectionDtlList: [],
                selectedDtlRows: [],
                isShowEditPanel: false,
            }
        })
        await repo.searchDtl(ids).then(data => {
            if (data && data.success) {
                collectionDispatch(prevState => {
                    return {
                        ...prevState,
                        collectionDtlList: data.data ?? [],
                    }
                })
            }
        });
    }

    const resetDefaultSelectedRows = () => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                isReselectRows: false,
                tempSelectedRows: []
            }
        })
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }

    const onTempDeleteCollectionDtl = (selectedDtlRows: CollectionDetailEntity[]) => {
        collectionDispatch(prevState => {
            return {
                ...prevState,
                currentDtlAddRowList: selectedDtlRows
            }
        })
    }

    return {
        searchDtl: searchDtl,
        onleaveDtl: onleaveDtl,
        onReprint: onReprint,
        onShowEditPanel: onShowEditPanel,
        loadDropdownOption: loadDropdownOption,
        onSearch: onSearch,
        updateSelectedDtlRows: updateSelectedDtlRows,
        updateSelectedRows: updateSelectedRows,
        onDtlRowDoubleClick: onDtlRowDoubleClick,
        onRowDoubleClick: onRowDoubleClick,
        onDeleteHdrClick: onDeleteHdrClick,
        onSearchCriteriaResetClick: onSearchCriteriaResetClick,
        onSearchClick: onSearchClick,
        onDateRangeChange: onDateRangeChange,
        onSearchFieldChange: onSearchFieldChange,
        onCheckboxChange: onCheckboxChange,
        onTextAreaChange: onTextAreaChange,
        onCloseClick: onCloseClick,
        onSearchDtl: onSearchDtl,
        onCloseEidtPanel: onCloseEidtPanel,
        onEditFieldChange: onEditFieldChange,
        onSaveCollectionDtl: onSaveCollectionDtl,
        onDeleteCollectionDtl: onDeleteCollectionDtl,
        onConfirmHdr: onConfirmHdr,
        onEditHeaderCick: onEditHeaderCick,
        onApplyCollection: onApplyCollection,
        resetDefaultSelectedRows: resetDefaultSelectedRows,
        setIsSearchLoading: setIsSearchLoading,
        onSaveClicked: onSaveClicked,
        onShowAddPanel: onShowAddPanel,
        onEditTempPaymentData: onEditTempPaymentData,
        onTempDeleteCollectionDtl: onTempDeleteCollectionDtl

    }
}